import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { BrowserRouter, Route, Routes } from 'react-router';
import Header from '@/components/Header';
import Meeting from '@/pages/Meeting';
import TgAiChat from '@/pages/TgAiChat';
import MeetingMaterials from './pages/MeetingMaterials';
import CreateMeeting from '@/pages/CreateMeeting';
import Landing from '@/pages/Landing';
import VerifyAssistantInviteToken from '@/pages/VerifyAssistantInviteToken';
import NotFound from '@/pages/NotFound';
import { ToastManager } from '@/components/ToastManager';

import './App.scss';
import '@livekit/components-styles';

function App() {
  return (
    <>
      <ToastManager />
      <div id="app">
        <BrowserRouter>
          <Header withBorder />
          <Routes>
            <Route path="/" element={<CreateMeeting />} />
            <Route path="/landing" element={<Landing />} />
            <Route path="/meeting/:meetingUid" element={<Meeting />} />
            <Route
              path="/meeting/assistant/:assistantInviteToken"
              element={<VerifyAssistantInviteToken />}
            />
            <Route path="/meeting/:meetingUid/materials" element={<MeetingMaterials />} />
            <Route path="/ai/answers/:answerUid" element={<TgAiChat />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </div>
    </>
  );
}

export default App;
